module.exports = __webpack_public_path__ + "img/Bodice-Front-B4-Gb-Da-Ea.12c50855.png";